import { type Dispatch, type SetStateAction } from 'react';

import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { useParams } from 'react-router-dom';

import { parkingManagementMessages } from 'src/features/parkingManagement/utils';
import ConfirmationModal from 'src/registry/components/blocks/ConfirmationModal.tsx';
import { generalMessages } from 'src/utils/messages.ts';

import type { AdditionalServices } from 'src/features/parkingManagement/types/additionalServices.ts';

type DeleteAdditionalServiceProps = {
    setIsModalOpen: Dispatch<SetStateAction<boolean>>;
    deleteService: ({ id, parkingId }: { id: number; parkingId: string }) => void;
    selectedService: AdditionalServices;
};

const DeleteAdditionalService = ({ setIsModalOpen, selectedService, deleteService }: DeleteAdditionalServiceProps) => {
    const { parkingId } = useParams();

    return (
        <ConfirmationModal
            isModalOpen={true}
            setIsModalOpen={setIsModalOpen}
            dialogDetails={{
                title: { ...parkingManagementMessages.deleteService, values: { name: '' } },
                subTitle: { ...parkingManagementMessages.deleteService, values: { name: selectedService.name } },
                icon: faTrashAlt,
                confirmationMessage: {
                    ...parkingManagementMessages.deleteServiceConfirmation,
                    values: { name: selectedService.name },
                },
            }}
            callbackButton={{
                variant: 'destructiveLight',
                buttonTitle: generalMessages.delete,
                callbackFn: () => {
                    if (selectedService) {
                        return (
                            deleteService({ id: selectedService.id, parkingId: parkingId || '' }),
                            setIsModalOpen(false)
                        );
                    }
                },
            }}
        />
    );
};

export default DeleteAdditionalService;
